// import redux
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../features/store";
import {alertsCloseAction} from "../features/sliceReducer/interactionReducer";

// import material-ui
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import ErrorIcon from '@material-ui/icons/Error';

import {
  deleteFactory,
  deleteFactoryAction,
} from "../features/sliceReducer/factoryListReducer";

export default function AlertDialog() {
  const dispatch = useDispatch();

  const {alertsToggle, alertContent, alertAction} = useSelector(
    (state: RootState) => state.interaction
  );
  const {userToken} = useSelector((state: RootState) => state.auth);

  return (
    <div>
      <Dialog
        open={alertsToggle}
        onClose={() => dispatch(alertsCloseAction())}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"><ErrorIcon color="secondary" /> {"주의"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {alertContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => dispatch(alertsCloseAction())} color="primary">
            취소
          </Button>
          <Button
            onClick={() => {
              dispatch(alertsCloseAction());
              dispatch(alertAction);
            }}
            color="primary"
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
